import useDelayOnMount from "@ch/helpers/hooks/useDelayOnMount";
import type { FC } from "react";
import ComponentLoader, { type ComponentLoaderProps } from ".";

export type DelayedComponentLoaderProps = ComponentLoaderProps & {
  delay?: number;
};

const DelayedComponentLoader: FC<DelayedComponentLoaderProps> = (props) => {
  const { delay = 750, ...rest } = props;

  const { isComplete } = useDelayOnMount({
    delay,
  });

  if (isComplete) {
    return <ComponentLoader {...rest} />;
  }

  return <div />;
};

export { DelayedComponentLoader };
